module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_resort-9c605c8c1516351f64c5619a5e164676.webp";